import * as Types from "../constants/TypeActions";

export const setUser = (body) => {

  return (dispatch) => {
    const d = (result) => {
      return {
        type: Types.SET_USER,
        result,
      };
    };
    return dispatch(d(body));

  };


};
